import { render, staticRenderFns } from "./HeaderBurgerButton.vue?vue&type=template&id=03b3a47d&scoped=true&lang=pug&"
import script from "./HeaderBurgerButton.vue?vue&type=script&lang=js&"
export * from "./HeaderBurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBurgerButton.vue?vue&type=style&index=0&id=03b3a47d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b3a47d",
  null
  
)

export default component.exports